import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AnalyticsService } from '@app/global services';
import {
  EVENT_ACAO_GERENCIAMENTO,
  IContentEventApi
} from '@app/global services/analytics-services';
import { IPedidoImagem } from '@app/modules/pedidos/model/pedidos.model';
import { timer } from 'rxjs';

@Component({
  selector: 'diaog-imgs-pedido',
  templateUrl: './dialog-imgs-pedido.component.html',
  styleUrls: ['./dialog-imgs-pedido.component.scss']
})
export class DialogImgsPedidoComponent implements OnInit {
  loading = true;

  responsiveOptions = [
    {
      breakpoint: '1199px',
      numVisible: 1,
      numScroll: 1
    },
    {
      breakpoint: '991px',
      numVisible: 2,
      numScroll: 1
    },
    {
      breakpoint: '767px',
      numVisible: 1,
      numScroll: 1
    }
  ];

  imagens = [] as IPedidoImagem[];

  constructor(
    public router: Router,
    protected analyticsService: AnalyticsService,
    public dialogRef: MatDialogRef<DialogImgsPedidoComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { imagens: IPedidoImagem[] },
    public dialog: MatDialogRef<DialogImgsPedidoComponent>
  ) {
    this.imagens = data.imagens;
  }

  ngOnInit() {
    timer(2000).subscribe(() => {
      this.loading = false;
      this.analyticsService.trackEventUseApi(EVENT_ACAO_GERENCIAMENTO, {
        conteudo: JSON.stringify(this.data.imagens),
        origem: `VISUALIZAR IMAGENS DO PEDIDO - ${this.router.url}`
      } as IContentEventApi);
    });
  }
}
